export enum CblImportReason {
    ChapterMissing = 0,
    VolumeMissing = 1,
    SeriesMissing = 2,
    NameConflict = 3,
    AllSeriesMissing = 4,
    EmptyFile = 5,
    SeriesCollision = 6,
    AllChapterMissing = 7,
    Success = 8,
    InvalidFile = 9
}